import type { EventDto } from '@odo/shared-ui';

export type EventStatus = 'disabled' | 'upcoming' | 'active' | 'past';

/**
 * Derived, never stored: `disabled` wins over the show window - an admin who
 * disables a currently-running event expects the list to say so, not
 * "active".
 */
export function eventStatus(event: EventDto, now: number = Date.now()): EventStatus {
    if (!event.enabled) return 'disabled';
    const showFrom = new Date(event.showFrom).getTime();
    const showUntil = new Date(event.showUntil).getTime();
    if (now < showFrom) return 'upcoming';
    if (now > showUntil) return 'past';
    return 'active';
}

export const EVENT_STATUS_LABEL: Record<EventStatus, string> = {
    disabled: 'Disabled',
    upcoming: 'Upcoming',
    active: 'Active',
    past: 'Past'
};

// Solid, saturated pairs for SolidStatusPill's `toneClassName` - the same
// treatment the Work Queue uses for manufacturer status, which is what the
// lead asked events to match.
export const EVENT_STATUS_TONE: Record<EventStatus, string> = {
    disabled: 'text-white bg-gray-400',
    upcoming: 'text-white bg-blue-600',
    active: 'text-white bg-emerald-600',
    past: 'text-white bg-gray-500'
};
